<template src="./LayoutTop.html"></template>
<style src="./LayoutTop.scss" lang="scss"></style>
<script>
export default {
    name: 'LayoutTop',

    computed: {
        description() {
            return this.$store.state.description
        },

        descriptionFull() {
            return this.$store.state.descriptionFull
        },

        formType() {
            return this.$store.state.form.type
        },

        index() {
            return this.$store.state.form.index
        },

        image1() {
            return this.$store.state.image1
        },

        image2() {
            return this.$store.state.image2
        },

        iconPath() {
            // return ['ee-au', 'ee-dom'].includes(this.formType) ? '/static/svg/ico-electric.svg' : '/static/svg/ico-gas.svg'
            return ['ee-au', 'ee-dom'].includes(this.formType) ? '/static/img/luce.png' : '/static/img/gas.png'
        },

        title() {
            return this.$store.state.title
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/LayoutTop/LayoutTop.vue